import { render, staticRenderFns } from "./CustomSwalFooter.vue?vue&type=template&id=6fba9e4a"
import script from "./CustomSwalFooter.vue?vue&type=script&lang=js"
export * from "./CustomSwalFooter.vue?vue&type=script&lang=js"
import style0 from "./CustomSwalFooter.vue?vue&type=style&index=0&id=6fba9e4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports